export default "__VITE_ASSET__c68ebdab__"